import { Controller } from "stimulus"

export default class extends Controller{

  async handleStoreChange(event){
    const store = "store";
    const url = new URL(event.params.url);
    const storeId = event.target.value;

    if (storeId == "")
      url.searchParams.delete(store);
    else
      url.searchParams.set(store, storeId);

    window.location.href = url;
  }
}